import React, { useRef, useState } from 'react';

import { MAX_USERNAME_LENGTH } from '@/pages/Onboarding/constants';

import {
  InputContainer,
  InputWrapper,
  StyledInput,
  SuggestionItem,
  SuggestionsContainer,
} from './DominateInputWithOptions.styles';

export type OptionType = {
  id: string;
  value: string;
  label: string;
};

export interface DominateInputWithOptionsProps {
  options?: OptionType[];
  value?: string;
  onChange?: (value: string) => void;
  onSelect?: (option: OptionType) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  autoFocus?: boolean;
}

export const DominateInputWithOptions: React.FC<
  DominateInputWithOptionsProps
> = ({
  options = [],
  value = '',
  onChange,
  onSelect,
  placeholder = '',
  disabled = false,
  className = '',
  autoFocus = false,
}) => {
  const [inputValue, setInputValue] = useState<string>(value);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (newValue.length <= MAX_USERNAME_LENGTH) {
      setInputValue(newValue);
      onChange?.(newValue);
    }
  };

  const handleSuggestionSelect = (option: OptionType) => {
    setInputValue(option.label);
    onChange?.(option.label);
    onSelect?.(option);
  };

  return (
    <InputWrapper className={className}>
      <InputContainer>
        <StyledInput
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
        />
      </InputContainer>

      {options.length > 0 && (
        <SuggestionsContainer>
          {options.map((option) => (
            <SuggestionItem
              key={option.id || option.label}
              onClick={() => handleSuggestionSelect(option)}
            >
              {option.label}
            </SuggestionItem>
          ))}
        </SuggestionsContainer>
      )}
    </InputWrapper>
  );
};

export default DominateInputWithOptions;
